import styled from "styled-components";

export const HeaderWrapper = styled.div`
  overflow: visible;
  background-image: url(${(props) => props.bg});
  background-repeat: no-repeat;
  background-size: cover;
  @media (max-width: 768px) {
    background-size: 200% auto;
  }

  /* Homepage, desktop: the header runs to 90px above the fold and the hero
     takes whatever the top bar and navbar leave; its image overhangs those
     last 90px, so it ends exactly at the bottom of the screen. */
  &.header--home {
    @media (min-width: 769px) {
      display: flex;
      flex-direction: column;
      min-height: calc(100vh - 90px);
      & > .hero {
        flex: 1 1 auto;
      }
    }
  }
`;
